import React, { useState } from "react";
import { controlToastState, Modal } from "risa-oasis-ui_v2";
import { killSwitch } from "../../../api/postCall/killSwitch";
import { ModalId } from "../../../enums/modalId";
import WarningIcon from "../../../svg/warningIcon";

interface ToggleSwitchConfirmationDialogProps {
  clientId: string;
  onClose: () => void;
  onConfirm?: () => void;
  metaData?: {
    id?: string;
    switchState?: boolean;
  };
}

const ToggleSwitchConfirmationDialog: React.FC<
  ToggleSwitchConfirmationDialogProps
> = ({ onClose, onConfirm, clientId, metaData }) => {
  const [comments, setComments] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const isEnabling = metaData?.switchState === true;

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const payload = {
        grid_identifier: metaData?.id || "",
        client_id: clientId,
        agent_mode: isEnabling,
        remarks: comments,
      };
      const response = await killSwitch(payload);

      if (response.success) {
        controlToastState(`kill-switch-success`);
        onConfirm?.();
      } else {
        controlToastState(`kill-switch-failure`);
        onClose();
      }
    } catch (error) {
      console.error("Error confirming toggle switch:", error);
      controlToastState(`kill-switch-failure`);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      dialogId={ModalId.TOGGLE_SWITCH_CONFIRMATION_DIALOG}
      title={isEnabling ? "Enable Automation" : "Remove Automation"}
      onCancel={onClose}
      onClose={onClose}
      onSave={handleConfirm}
      cancelText="Cancel"
      saveButtonText={loading ? "Confirming..." : "Confirm"}
      disableSave={!comments || loading}
    >
      <div className="toggle-switch-confirmation-content flex flex-col gap-4">
        <div
          className={`warning-icon-automation flex flex-row items-center gap-2 bg-red-50 p-2`}
        >
          <WarningIcon outerFillColor="black" height="16" width="16" />
          <div className="text-small font-normal">
            {isEnabling
              ? `This will enable Agent Mode`
              : `This will pause drug from Agent Mode`}
          </div>
        </div>
        <div className="comments-section w-full">
          <div className="comments-section header mb-2 text-small font-normal text-primaryGray-2">
            {isEnabling
              ? "Please provide the reason for enabling Agent Mode."
              : "Please provide the reason for shifting drug to Human."}
          </div>
          <div className="comments-section comments-textarea">
            <textarea
              className="h-20 w-full rounded-md border border-gray-300 p-2 text-tiny font-normal"
              placeholder=""
              onChange={(e) => setComments(e.target.value)}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ToggleSwitchConfirmationDialog;
